import { ReactNode } from "react";

interface Props {
  content: ReactNode;
  active: boolean;
  disabled: boolean;
  onClick: () => void;
  isCustomContent: boolean;
}

export const NavigationButton = ({
  content,
  active,
  disabled,
  onClick,
  isCustomContent,
}: Props) => {
  return (
    <>
      {isCustomContent ? (
        content
      ) : (
        <button
          className={`${disabled ? "pointer-events-none" : ""}`}
          type="button"
          onClick={() => {
            if (!disabled) {
              onClick();
            }
          }}
        >
          {typeof content === "string" ? (
            <div
              className={`text-xl text-text_primary font-medium ${
                !active ? "text-opacity-40" : ""
              }`}
            >
              {content}
            </div>
          ) : (
            <>{content}</>
          )}
        </button>
      )}
    </>
  );
};
